export const sentimentList = {
    "-1": {
        sentiment: -1,
        name: "bad",
        colorName: "red",
        color: "#FE837B",
        mapFillColor: "#FA665C",
        textColor: "#fff"
    },
    "0": {
        sentiment: 0,
        name: "neutral",
        colorName: "gray",
        color: "#ADB6CC",
        mapFillColor: "#7B87A5",
        textColor: "#fff"
    },
    "1": {
        sentiment: 1,
        name: "good",
        colorName: "green",
        color: "#C7EEA6",
        mapFillColor: "#C4F487",
        textColor: "#373D3F"
    }
};